import { Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { concatClassnames } from "shared/utils/concatClassnames";

interface FormGroupProps {
  children: React.ReactNode;
  className?: string;
  isInline?: boolean;
  displayError?: boolean;
  errorMessage?: string;
}

const FormGroup: React.FC<FormGroupProps> = ({
  children = <></>,
  className,
  isInline = false,
  displayError = false,
  errorMessage = "",
  ...rest
}) => {
  return (
    <div
      className={concatClassnames(
        "gg-col-span-12 gg-flex",
        isInline ? "gg-space-x-2 gg-flex-row gg-items-center" : "gg-flex-col",
        className
      )}
      {...rest}
    >
      {children}

      <Transition.Root show={displayError && !!errorMessage} as={Fragment}>
        <Transition.Child
          as={Fragment}
          enter="gg-ease-out gg-duration-300"
          enterFrom="gg-opacity-0"
          enterTo="gg-opacity-100"
          leave="gg-ease-in gg-duration-200"
          leaveFrom="gg-opacity-100"
          leaveTo="gg-opacity-0"
        >
          <p
            className={
              "gg-mt-2 gg-text-red-700 gg-text-xs gg-items-center gg-flex "
            }
          >
            <span
              className={concatClassnames(
                "gg-col-span-1 gg-text-white gg-block gg-bg-red-700 gg-flex gg-items-center gg-justify-center",
                "gg-rounded-full gg-w-5 gg-h-5 gg-text-center",
                "gg-text-sm gg-mr-2 gg-shrink-0"
              )}
            >
              !
            </span>
            <span className={"gg-col-span-10 "}>{errorMessage}</span>
          </p>
        </Transition.Child>
      </Transition.Root>
    </div>
  );
};

export default FormGroup;
